import React from 'react';
import { useZitoneoServices } from '../../contexts/ZitoneoContentContext';
import ZitoneoServicesSidebar from './zitoneoHotelServices/ZitoneoServicesSidebar';
import '../../stylesheets/hotel-content-services.scss';
import Sidebar from './zitoneoHotelServices/Sidebar';
import ZitoneoRoomTitle from './zitoneoHotelServices/room/ZitoneoRoomTitle';
import { useZitoneoUI } from '../../contexts/ZitoneoUIContext';
import {
    VisibleContentScope,
    ZitoneoContentType,
} from '../../types/zitoneoServicesTypes';
import ZitoneoContentTypeTabs from './ZitoneoContentTypeTabs';
import ServicesTab from './ServicesTab';
import ImagesTab from './zitoneoHotelServices/images/ImagesTab';

const EditorView = () => {
    const { HotelServices: hotelServices } = useZitoneoServices();
    const { visibleContentScope, visibleContentType } = useZitoneoUI();

    return (
        <>
            <section className='hotel-content-services hotel-content-services__container'>
                <ZitoneoServicesSidebar />
                <div className='hotel-content-services__content'>
                    <div className='zitoneo__editor-view'>
                        {visibleContentScope === VisibleContentScope.ROOM ? (
                            <ZitoneoRoomTitle />
                        ) : (
                            ''
                        )}
                        <ZitoneoContentTypeTabs />
                        <div className='zitoneo__main-section'>
                            {visibleContentType ===
                            ZitoneoContentType.SERVICES ? (
                                <ServicesTab />
                            ) : (
                                <ImagesTab />
                            )}
                        </div>
                    </div>
                    {visibleContentType === ZitoneoContentType.SERVICES &&
                    hotelServices.length ? (
                        <Sidebar />
                    ) : (
                        ''
                    )}
                </div>
            </section>
        </>
    );
};

export default EditorView;
